import { UseFormReturn } from "react-hook-form";
import React, { useMemo } from "react";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { InsuranceCalculationBaseEnum, InsuranceEntity } from "../../entity";
import { TaxationComponent } from "./TaxationComponent";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { WitLabel } from "../../styles";
import { SectionComponent } from "./SectionComponent";

export const messages = defineMessages({
  typology: { id: "insurance.form.typology", defaultMessage: "Typology" },
  taxationBase: {
    id: "insurance.form.taxationBase",
    defaultMessage: "Base imponible",
  },
  calculationBasePlaceholder: {
    id: "insurance.form.calculationBase.placeholder",
    defaultMessage: "Seleccionar...",
  },
  accommodationAndExtrasCalculationBase: {
    id: "insurance.form.calculationBase.accommodationAndExtras",
    defaultMessage: "Alojamiento y servicios extras",
  },
  accommodationOnlyCalculationBase: {
    id: "insurance.form.calculationBase.accommodationOnly",
    defaultMessage: "Alojamiento",
  },
});

export function Typology(props: UseFormReturn<InsuranceEntity> & { children?: React.ReactNode }) {
  const intl = useIntl();
  const { children, register } = props;

  return useMemo(
    () => (
      <>
        <FormGroup as={Col}>
          <FormLabel column sm={12}>
            <WitLabel>
              <FormattedMessage {...messages.typology} />
            </WitLabel>
          </FormLabel>

          <FormLabel column sm={12} className="font-weight-bold">
            <FormattedMessage {...messages.taxationBase} />
          </FormLabel>
          <Col sm={3}>
            <select className="form-control" {...register("calculationBase", { required: true })}>
              <option value="" disabled>
                {intl.formatMessage(messages.calculationBasePlaceholder)}
              </option>
              {Object.values(InsuranceCalculationBaseEnum).map(key => (
                <option value={key} key={key}>
                  {intl.formatMessage(messages[`${key}CalculationBase`])}
                </option>
              ))}
            </select>
          </Col>
        </FormGroup>
        {children}
      </>
    ),
    [intl, children, register]
  );
}

Typology.TaxationComponent = TaxationComponent;
Typology.SectionComponent = SectionComponent;
